module.exports = __webpack_public_path__ + "img/spectrogram.a8b3698d.webp";